import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DocumentUploadModal } from "@/components/document-upload-modal"
import { useDocumentsUpload } from "@/routes/_layout/documents/-components/use-documents-upload"

export const Route = createFileRoute(
  "/_layout/airworthiness-directives/upload",
)({
  component: UploadDirectiveRoute,
})

function UploadDirectiveRoute(): React.ReactElement {
  const navigate = useNavigate()
  const { uploadFile, isUploading } = useDocumentsUpload("tenant")
  const close = () =>
    navigate({ to: "/airworthiness-directives", search: true })

  return (
    <DocumentUploadModal
      open
      onOpenChange={(open) => {
        if (!open) close()
      }}
      onUpload={async (file) => {
        await uploadFile(file)
        close()
      }}
      isUploading={isUploading}
    />
  )
}
